__turbopack_context__.v({
  "large": "spacer-module__TNtpNa__large",
  "medium": "spacer-module__TNtpNa__medium",
  "small": "spacer-module__TNtpNa__small",
  "spacer": "spacer-module__TNtpNa__spacer",
});
